{
  "title": "Eyebite",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level necromancy",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "For the spell’s duration, your eyes become an inky void imbued with dread power. One creature of your choice within 60 feet of you that you can see must succeed on a Wisdom saving throw or be affected by one of the following effects of your choice for the duration. On each of your turns until the spell ends, you can use your action to target another creature but can’t target a creature again if it has succeeded on a saving throw against this casting of eyebite.",
    "Asleep. The target falls unconscious. It wakes up if it takes any damage or if another creature uses its action to shake the sleeper awake.",
    "Panicked. The target is frightened of you. On each of its turns, the frightened creature must take the Dash action and move away from you by the safest and shortest available route, unless there is nowhere to move. If the target moves to a place at least 60 feet away from you where it can no longer see you, this effect ends.",
    "Sickened. The target has disadvantage on attack rolls and ability checks. At the end of each of its turns, it can make another Wisdom saving throw. If it succeeds, the effect ends."
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
